import React from 'react';
import { Holiday } from '../../../Holiday/store/selectors';
import HolidaysBlock from '../../../../components/presentational/HolidaysBlock';
import { SHOW_MORE_HOLIDAYS } from '../../lib/ga';
import { trackEvent } from '../../../../lib/ga';
import styled, { StylesProps } from '../../../../lib/styles';
import blockStyles from './Block_styles';
import Spacer from '../../../../components/presentational/Spacer';
import { compose } from 'recompose';
export interface HolidayBlockData {
  type: 'holiday_block';
  holidays: Holiday[];
  title?: string;
  subtitle?: string;
}

interface HolidayBlockProps {
  block: HolidayBlockData;
  blockIndex: number;
}

const HolidayBlock = ({
  block,
  blockIndex,
  styles,
}: HolidayBlockProps & StylesProps<typeof blockStyles>) => {
  if (!block.holidays.length) {
    return <div />;
  }
  return (
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <HolidaysBlock
          holidays={block.holidays}
          title={block.title || 'Book your next holiday'}
          description={block.subtitle}
          hasMore
          key={blockIndex}
          lazy={true}
          onShowMore={() => {
            window.open('//travelat60.com', '_blank');
            trackEvent(SHOW_MORE_HOLIDAYS, { transport: 'beacon' });
          }}
        />
      </Spacer>
    </div>
  );
};

export default compose(styled(blockStyles))(HolidayBlock);
